import React from 'react'
import * as R from 'ramda'
import { useSelector } from 'react-redux'
import { Button, Badge } from '@material-ui/core'
import ChatIcon from '@material-ui/icons/Chat'
import clsx from 'clsx'
import { makeStyles } from '@material-ui/styles'
import { IntlContext } from 'app/translations/intl-context'
import { Routes } from 'app/services/routeService/routeService'
import { Link } from 'react-router-dom'

const useStyle = makeStyles(() => ({
  text: {
    color: '#3A3A3A !important',
  },
  icon: {
    color: '#3A3A3A !important',
  },
  chatIcon: {
    color: '#3A3A3A !important',
    fontSize: 'large',
  },
  badge: {
    fontSize: '5px',
  },
}))

function ConversationMenu(props) {
  const classes = useStyle(props)
  const hasUnreadMessage = useSelector(
    R.view(R.lensPath(['conversation', 'hasUnreadMessage'])),
  )

  return (
    <IntlContext.Consumer>
      {() => (
        <React.Fragment>
          <Button>
            <div className="flex item-center">
              <Link className="flex item-center" to={Routes.conversation()}>
                {hasUnreadMessage ? (
                  <Badge color="error" badgeContent=" " variant="dot">
                    <ChatIcon className={clsx(classes.chatIcon)} />
                  </Badge>
                ) : (
                  <ChatIcon className={clsx(classes.chatIcon)} />
                )}
              </Link>
            </div>
          </Button>
        </React.Fragment>
      )}
    </IntlContext.Consumer>
  )
}

export default ConversationMenu
